export default "__VITE_ASSET__CLvDsQxl__"